<div
  class="canvas-component flex-row"
  [class.crosshair]="cs.shapeAddMode"
  (click)="clickCanvas()"
  #canvasComponent
>
  <div class="recording-overlay" *ngIf="isExportInProgress$ | async">
    <div class="flex-column center gap-20">
      <div class="fs-14">Video is being exported...</div>
      <div class="progress-bar">
        <div class="frame"></div>
        <div
          *ngIf="(relativeAnimationTime$ | async) > 0"
          class="fill"
          [style.width.px]="(relativeAnimationTime$ | async) * 240"
        ></div>
      </div>
      <div class="cancel">Cancel</div>
      <!-- 
      <div>
        <div class="fs-14">{{ relativeAnimationTime$ | async }}</div>
      </div>
      -->
    </div>
  </div>

  <div class="base-overlay" *ngIf="overlay$ | async">
    <ng-container [ngSwitch]="overlay$ | async">
      <div *ngSwitchCase="'image-selector'">Image Selector</div>
      <image-prompt-panel *ngSwitchCase="'image-prompt'"></image-prompt-panel>
      <!-- 
      <div
        *ngSwitchCase="'image-prompt'"
        class="image-prompt"
        (click)="$event.stopPropagation()"
      >
        <textarea
          placeholder="Enter image prompt"
          (keyup)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
        ></textarea>
        <div class="flex-row justfity-end row">
          <div class="arrow-border">
            <nw-icon type="arrow_upward"></nw-icon>
          </div>
        </div>
      </div>
      -->
    </ng-container>
  </div>

  <div class="flex-row flex-fill">
    <div class="flex-column fill-available-height flex-1-1-auto">
      <div class="flex-row flex-fill gap-8 p-8">
        <!-- <nw-new-element
          *ngIf="!(isPreviewShapeLoading$ | async)"
        ></nw-new-element> -->
        <!-- <nw-control-panel></nw-control-panel> -->
        <div
          class="flex-1-1-auto"
          style="position: relative; background: transparent"
          (mouseenter)="onCanvasMouseEnter()"
          (contextmenu)="onRightClick($event)"
          appDnd
          (fileDropped)="onFileDropped($event)"
          #canvasContainer
        >
          <!-- <nw-canvas-control-panel></nw-canvas-control-panel> -->
          <nw-spacing-controller
            *ngIf="
              shapeService.selectionAlignType && serviceDragState == 'idle'
            "
          ></nw-spacing-controller>

          <nw-comment-thread
            *ngIf="commentToShow$ | async as commentToShow"
            [config]="commentToShow"
          ></nw-comment-thread>

          <div
            *ngIf="cs.showFitCanvas"
            class="flex-row gap-8 fs-12 pointer"
            style="
              position: absolute;
              z-index: 1;
              bottom: 4px;
              left: 50%;
              transform: translate(-50%, -50%);
              border: 1px solid white;
              padding: 6px;
              border-radius: 4px;
            "
            (click)="cs.fitCanvas()"
          >
            <div style="color: white">Fit slide</div>
            <nw-icon
              type="fit_screen"
              [size]="18"
              [outlined]="true"
              color="white"
            ></nw-icon>
          </div>
          <!-- <ng-container *ngIf="cs.previewShape">
            <div
              *ngIf="bgSelectorPosition$ | async as bgSelectorPosition"
              style="
                width: 14px;
                height: 14px;
                border: 1.25px solid white;
                border-radius: 3px;
                position: relative;
                z-index: 99;
              "
              [style.background]="canvasBackgroundColor$ | async"
              [style.left.px]="
                bgSelectorPosition?.x +
                cs._screenX * bgSelectorPosition?.scale -
                22
              "
              (click)="openCanvasBgColorEdit()"
              [style.top.px]="bgSelectorPosition?.y - 22"
            ></div>
          </ng-container> -->

          <!-- <nw-container-panel></nw-container-panel> -->
          <div
            fxFlex="1 1 auto"
            [style.visibility]="
              (isPreviewShapeLoading$ | async) ? 'hidden' : 'visible'
            "
            #canvas
            id="_canvas"
            (click)="click2()"
          ></div>

          <div *ngIf="isPreviewShapeLoading$ | async" class="file-is-loading">
            <div class="fs-14 blink">File is being loaded</div>
          </div>
        </div>
        <!-- <nw-animation-panel
      *ngIf="
      !shapeService.previewShapeIsLoading && !(isStoryBoardOpened$ | async)
      "
    ></nw-animation-panel> -->
        <!-- *ngIf="!(isPreviewShapeLoading$ | async)" -->
      </div>

      <!-- dirty hack -->
      <!-- <div style="height: 114px">
        <nw-slide-viewer
          *ngIf="!(isPreviewShapeLoading$ | async)"
        ></nw-slide-viewer>
      </div> -->
    </div>
    <!-- <nw-shape-attribute-panel></nw-shape-attribute-panel> -->
  </div>
  <!-- 
  <div class="fill-available-height flex-column" style="position: relative">
    <nw-zoom-panel></nw-zoom-panel>
    <nw-shape-attribute-panel fxFlex="1 1 auto"></nw-shape-attribute-panel>
  </div> 
  -->

  <!-- <div>
    <nw-stroke-panel></nw-stroke-panel>
  </div> -->

  <ng-container *ngIf="!recordMode">
    <nw-component-search
      *ngIf="showComponentSearch$ | async"
    ></nw-component-search>
    <nw-image-processing-panel></nw-image-processing-panel>
  </ng-container>

  <ng-container *ngIf="!recordMode">
    <nw-general-selector *ngIf="cs.generalSelectorConfig"></nw-general-selector>
  </ng-container>
</div>
